module.exports = __webpack_public_path__ + "img/78600.e3bdfc0b.jpg";